export const getUrlParam = ((parameter:string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(parameter);
});

export const setUrlParam = ((parameter: string, value: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(parameter, value);
  window.history.replaceState(null, null, `?${searchParams.toString()}`);
});

export default {
  getUrlParam,
  setUrlParam,
};
